import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Tabs,
  Tab,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

const SignatureModal = ({ open, onClose, onSave, fullName }) => {
  const sigCanvasRef = useRef(null);
  const [tab, setTab] = useState(0);
  const [selectedStyle, setSelectedStyle] = useState(0);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [fillAll, setFillAll] = useState(false);
  const premadeStyles = [
    { font: "'StyleScript', cursive" },
    { font: "'DancingScript', cursive" },
    { font: "'AlexBrush', cursive" },
  ];

  const handleClear = () => {
    sigCanvasRef.current.clear();
    setTermsAccepted(false);
    setFillAll(false);
  };

  const handleSave = (e) => {
    let dataUrl;
    if (tab === 0) {
      if (sigCanvasRef.current.isEmpty()) return;
      dataUrl = sigCanvasRef.current.getTrimmedCanvas().toDataURL("image/png");
    } else {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d", { willReadFrequently: true });
      canvas.width = 400;
      canvas.height = 100;
      ctx.fillStyle = "#000";
      ctx.font = `36px ${premadeStyles[selectedStyle].font}`;
      ctx.fillText(fullName, 20, 60);
      dataUrl = canvas.toDataURL("image/png");
    }
    onSave(e, dataUrl, termsAccepted, fillAll);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Sign Document</DialogTitle>
      <DialogContent dividers>
        <Tabs value={tab} onChange={(_, val) => setTab(val)}>
          <Tab label="Draw" />
          <Tab label="Select Style" />
        </Tabs>

        {tab === 0 && (
          <Box sx={{ border: "1px solid #ccc", mt: 2 }}>
            <SignatureCanvas
              penColor="black"
              canvasProps={{
                width: 500,
                height: 150,
                className: "sigCanvas",
                style: {
                  cursor: "crosshair",
                },
              }}
              ref={sigCanvasRef}
            />
            <Box
              sx={{
                py: 0.5,
                width: "100%",
                backgroundColor: "#f3f3f3",
                borderTop: "2px solid #d3d3d3",
                boxShadow: "1px 6px 6px 4px rgba(0, 0, 0, 0.2)",
              }}
            >
              <Button onClick={handleClear}>Clear</Button>
            </Box>
          </Box>
        )}

        {tab === 1 && (
          <Box sx={{ mt: 2 }}>
            {premadeStyles.map((style, i) => (
              <Typography
                key={i}
                sx={{
                  fontFamily: style.font,
                  fontSize: "32px",
                  cursor: "pointer",
                  mb: 1,
                  border:
                    selectedStyle === i ? "2px solid green" : "1px solid #ccc",
                  p: 1,
                }}
                onClick={() => setSelectedStyle(i)}
              >
                {fullName}
              </Typography>
            ))}
          </Box>
        )}
        <Box mt={2} mb={1}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={fillAll}
                  onChange={(e) => {
                    setFillAll(!fillAll);
                  }}
                  sx={{ alignSelf: "flex-start" }}
                />
              }
              label={
                <Typography color="primary" fontWeight="bold" variant="body2">
                  I approve applying my signature to all required fields in this
                  document
                </Typography>
              }
            />
          </FormGroup>
        </Box>
        <Box>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={termsAccepted}
                  onChange={() => setTermsAccepted(!termsAccepted)}
                  sx={{ alignSelf: "flex-start" }}
                />
              }
              label={
                <Typography color="primary" fontWeight="bold" variant="body2">
                  By signing, I affirm that the information is accurate, and
                  this electronic signature is legally equivalent to my
                  handwritten signature.
                </Typography>
              }
            />
          </FormGroup>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setTermsAccepted(false);
            onClose();
          }}
        >
          Cancel
        </Button>
        <LoadingButton
          disabled={!termsAccepted}
          variant="contained"
          onClick={handleSave}
        >
          Sign Document
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default SignatureModal;
